// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const enFiles = import.meta.glob("../locales/en/*.json", {
  eager: true,
});

const arFiles = import.meta.glob("../locales/ar/*.json", {
  eager: true,
});

const resources = {
  en: {},
  ar: {},
};

Object.entries(enFiles).forEach(([path, module]) => {
  const namespace = path.split("/").pop().replace(".json", "");
  resources.en[namespace] = module.default;
});

Object.entries(arFiles).forEach(([path, module]) => {
  const namespace = path.split("/").pop().replace(".json", "");
  resources.ar[namespace] = module.default;
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, 
    },
    resources,
    defaultNS: "translation",
  });

export default i18n;
